import { CARD_HEIGHT, CARD_WIDTH, SMALL_MEDIA_HEIGHT, SMALL_MEDIA_WIDTH } from './constants';

export function getSizeForFreeform(
  size: { width: number; height: number },
  configuredWidth?: number
) {
  if (configuredWidth && configuredWidth < size.width) {
    const blockRatio = size.width / size.height;
    return {
      width: configuredWidth,
      height: configuredWidth / blockRatio,
    };
  }
  return size;
}

export function useFreeformSquareSizing(propsWidth, extOptions, containerSize) {
  let size = {
    width: CARD_WIDTH,
    height: CARD_HEIGHT,
  };

  // Allow user supplied width
  size = getSizeForFreeform(size, propsWidth);

  // Restrict to small media
  if (extOptions?.smallMedia) {
    size = {
      width: SMALL_MEDIA_WIDTH,
      height: SMALL_MEDIA_HEIGHT,
    };
  }

  // Make sure its never bigger than the container
  if (containerSize && size.width > containerSize) {
    size = getSizeForFreeform(size, containerSize);
  }

  return size;
}
